import { render, staticRenderFns } from "./FormSeparator.vue?vue&type=template&id=391439c2&scoped=true&"
import script from "./FormSeparator.vue?vue&type=script&lang=js&"
export * from "./FormSeparator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391439c2",
  null
  
)

export default component.exports